export default __webpack_public_path__ + "static/media/custom1b.75ce11f6.png";